import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Bike, Loader2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { APP_NAME, APP_TAGLINE } from "@/lib/brand";

const PUNTI = ["Schede officina, preventivi e firme su tablet", "Noleggi, agenda e promemoria WhatsApp", "Magazzino, cassa e documenti in PDF"];
const CAMPI = [["nome_negozio", "Nome del negozio", "text"], ["nome", "Il tuo nome", "text"], ["email", "Email", "email"], ["password", "Password (min. 8 caratteri)", "password"]];

export default function Registrati() {
  const { user, registra } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ nome_negozio: "", nome: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/impostazioni" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await registra(f);
      navigate("/impostazioni");
    } catch (e2) {
      setErr(formatError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-slate-50 lg:grid-cols-2">
      <div className="hidden flex-col justify-center bg-slate-900 p-16 text-white lg:flex">
        <div className="mb-8 flex items-center gap-3"><div className="flex h-10 w-10 items-center justify-center rounded-md bg-orange-600"><Bike className="h-6 w-6" /></div><span className="font-heading text-2xl font-extrabold">{APP_NAME}</span></div>
        <h1 className="font-heading text-4xl font-extrabold leading-tight">{APP_TAGLINE}</h1>
        <ul className="mt-8 space-y-3 text-slate-300">{PUNTI.map((p) => <li key={p} className="flex gap-2"><Check className="h-5 w-5 text-orange-500" />{p}</li>)}</ul>
        <p className="mt-10 text-sm text-slate-400">14 giorni gratis, senza carta. Poi 39 € al mese, disdici quando vuoi.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-lg border border-slate-200 bg-white p-8 shadow-sm" data-testid="registrati-form">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Prova gratuita 14 giorni</p>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Crea il tuo negozio</h2>
          </div>
          {CAMPI.map(([k, label, type]) => (
            <div key={k}>
              <Label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">{label}</Label>
              <Input type={type} required minLength={k === "password" ? 8 : 2} value={f[k]} onChange={(e) => setF((s) => ({ ...s, [k]: e.target.value }))} data-testid={`registrati-${k.replace("_", "-")}-input`} />
            </div>
          ))}
          {err && <p className="rounded-md bg-rose-50 p-2 text-sm text-rose-700" data-testid="registrati-error">{err}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="registrati-submit-button">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Inizia la prova gratuita"}
          </Button>
          <p className="text-center text-sm text-slate-500">Hai già un account? <Link to="/login" className="font-semibold text-orange-600 hover:underline" data-testid="registrati-login-link">Accedi</Link></p>
        </form>
      </div>
    </div>
  );
}
